import React from 'react';

import { MarketplaceAPI } from 'revibe-api';
import { Drawer, Separator, cn } from 'revibe-ui';
import { BLOG_ROUTES } from 'routes';

import { getDynamicRouteUrl } from 'modules/common/utils';

import { Link } from 'ui/components/Link';
import { fontVariables } from 'ui/fonts/fontVariables';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  categories?: MarketplaceAPI.BlogCategory[];
};

export const BlogPanel = ({ isOpen, onClose, categories }: Props) => {
  return (
    <Drawer
      scrollable
      open={isOpen}
      onOpenChange={onClose}
      position="right"
      className={cn(fontVariables, 'bg-black')}
    >
      <div className="h-full w-full bg-black">
        <div className="flex flex-col">
          <Link
            hasDecoration={false}
            to={BLOG_ROUTES.HOME}
            className="w-full px-4 py-8"
          >
            <p className="text-green-fluo font-syne text-4xl font-semibold uppercase">
              Stain
            </p>
          </Link>
          <div className="flex flex-col">
            {categories?.map((category) => (
              <Link
                to={getDynamicRouteUrl(BLOG_ROUTES.CATEGORY, {
                  category: category.slug,
                })}
                key={category.slug}
                className="border-green-fluo hover:bg-green-fluo border-b p-4 uppercase text-white first:border-t hover:text-black"
                hasDecoration={false}
              >
                {category.slug}
              </Link>
            ))}
            <Separator />
            <Link
              to={'/'}
              className="border-green-fluo hover:bg-green-fluo border-b p-4 uppercase text-white first:border-t hover:text-black"
              hasDecoration={false}
            >
              Shop
            </Link>
          </div>
        </div>
      </div>
    </Drawer>
  );
};
